<template>
  <div v-loading="loading" class="min_he400">
    <div class="site_zi" v-for="(item,i) in siteList" :key="item.id">
		<div v-show="isDisabled" class="flo_right site_tabs">
			<button v-notClick="isTosub" v-if="item.is_default != 1" class="lan" @click="Postaddresssetdefault(item.id)">设为默认地址</button><br>
			<button class="lan" v-notClick="isTosub" @click="setDizhi(item)">修改地址</button><br>
			<button class="lan red " v-notClick="isTosub" @click="Postaddressdel(item.id)">删除地址</button>
	 	 </div>
      <div class="site_title">
        <span>地址管理{{i+1}}</span>
        <span class="lan" v-if="item.is_default == 1">默认地址信息</span>
      </div>
      <div class="site_form clearfloat">
        <div class="form_left">单位:</div>
        <div class="form_right">
			<el-autocomplete clearable :disabled="item.isDisabled" class="inline-input"  v-model="item.unit" :fetch-suggestions="querySearch" 
			placeholder="试试搜索：清华" :trigger-on-focus="false"  @select="(e)=>handleSelect2(e,item)" >
				<template slot-scope="{ item }">
					<div class="name">{{ item.name }}</div>
				</template>
			</el-autocomplete>
        </div>
      </div>
      <div class="site_form clearfloat">
        <div class="form_left">收货人:</div>
        <div class="form_right">
			<el-input :disabled="item.isDisabled" v-model="item.realname" clearable></el-input>
		</div>
      </div>
      <div class="site_form clearfloat">
        <div class="form_left">地区:</div>
        <div class="form_right">
          <el-cascader v-model="item.addrid" :disabled="item.isDisabled" placeholder="试试搜索：上海市" :options="region" 
		  filterable :props="{ expandTrigger: 'hover' }" clearable >
		  </el-cascader>
        </div>
      </div>
      <div class="site_form clearfloat">
        <div class="form_left">详细地址:</div>
        <div class="form_right">
			<el-input :disabled="item.isDisabled" v-model="item.address" clearable></el-input>
		</div>
      </div>
      <div class="site_form clearfloat">
        <div class="form_left">手机:</div>
        <div class="form_right">
			<el-input :disabled="item.isDisabled" v-model="item.phone" clearable></el-input>
		</div>
      </div>
      <div class="site_form clearfloat">
        <div class="form_left">或固定电话:</div>
        <div class="form_right">
			<el-input :disabled="item.isDisabled" v-model="item.tel" clearable></el-input>
		</div>
      </div>
	  <div v-show="!item.isDisabled" class="site_form clearfloat">
        <div class="form_left"></div>
        <div class="form_right">
    		<el-button type="primary" @click="Postaddressupdate(item);">确 定</el-button>
			<el-button @click="quxiao(i)">取 消</el-button>
		</div>
      </div>
    </div>
	<!-- 添加地址 -->
    <div @click="dialogVisible=true" class="laing_btn">+新增地址</div>
		<el-dialog title="添加地址" :visible.sync="dialogVisible" width="600px" :before-close="closeform" :close-on-click-modal="false" >
		<div>
			<el-form :model="addruleForm" :rules="rules" ref="adddizhi" label-width="130px" class="demo-ruleForm">
				<el-form-item label="单位" prop="unit">
					<el-autocomplete  class="inline-input" v-model="addruleForm.unit" :fetch-suggestions="querySearch" 
					placeholder="试试搜索：清华" :trigger-on-focus="false"  @select="handleSelect" >
						<template slot-scope="{ item }">
							<div class="name">{{ item.name }}</div>
						</template>
					</el-autocomplete>
				</el-form-item>
				<el-form-item label="收货人" prop="realname">
					<el-input v-model="addruleForm.realname"></el-input>
				</el-form-item>
				<el-form-item label="地区" prop="addrid">
					<el-cascader v-model="addruleForm.addrid" placeholder="试试搜索：上海市" :options="region" 
						filterable expand-trigger="hover" clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item label="详细地址" prop="address">
					<el-input v-model="addruleForm.address"></el-input>
				</el-form-item>
				<el-form-item label="手机" prop="phone">
					<el-input v-model="addruleForm.phone"></el-input>
				</el-form-item>
				<el-form-item label="或者固定电话" prop="tel">
					<el-input v-model="addruleForm.tel"></el-input>
				</el-form-item>
				<el-form-item label="设为默认地址" prop="is_default">
					<el-switch v-model="addruleForm.is_default"></el-switch>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="closeform('')">取 消</el-button>
			<el-button v-preventReClick type="primary" @click="adddizhi">确 定</el-button>
		</span>
	</el-dialog>
  </div>
</template>

<script>
import city from '@/utlis/city.js'
export default {
  data() {
	var validatePass = (rule, value, callback) => {
		if (this.addruleForm.phone || this.addruleForm.tel) {
			callback();
		} else {
			callback(new Error('请输入手机或者固定电话'));
			// this.$refs.ruleForm.validateField('checkPass');
		}
	};
    return {
		loading:true,
		isTosub:true,
		addruleForm:{
			realname:'',//姓名
			phone:'',//电话
			address:'',//详细地址
			tel:'',//固定电话
			addrid:'',//地址
			is_default:0,//是否设为默认地址
			unit:'',//单位
		},
		rules:{
			realname:{ required: true, message: '请输入姓名', trigger: 'blur' },
			phone: { required: true, message: '请输入手机号', trigger: 'blur' },
			// tel:{ validator: validatePass, trigger: 'blur' },
			addrid:[{type: 'array', required: true, message: '请选择地区', trigger: 'change' }],
			address:{ required: true, message: '请输入详细地址', trigger: 'blur' },
			unit:{ required: true, message: '请输入单位', trigger: 'blur' },
		},
		setdizhiCopy:{},//地址
		isDisabled:true,//修改
		dialogVisible:false,//添加地址
		input:'233',
		region: [],// 地址三级
		siteList:[],//地址列表
    };
  },
  created(){
	// this.Postaddresstree();
	this.region = this.asd(city.data||[])
	this.Postaddressget();
  },
  methods: {
	handleSelect2(e,item){//修改选择单位
		item.unit = e.name;
		item.address_id = e.id;
	},
	quxiao(i){//修改取消
		this.siteList[i] = this.setdizhiCopy;
		this.siteList[i].isDisabled = true;
		this.isDisabled=true;
	},
	setDizhi(item){//修改地按下
		item.isDisabled = false;
		this.isDisabled = false;
		this.setdizhiCopy = Object.assign({}, item);
	},
	async Postaddressupdate(item){//修改地址?????
		if(!item.unit) this.$message({ message: '单位不能为空', type: 'warning' });
		else if(!item.realname) this.$message({ message: '收货人不能为空', type: 'warning' });
		else if(!item.addrid.length) this.$message({ message: '地址不能为空', type: 'warning' });
		else if(!item.address) this.$message({ message: '详细地址不能为空', type: 'warning' });
		else if(item.phone){
			item.isDisabled = true;
			let dizhi = '';
				item.addrid.forEach(v=>{
					dizhi+=v+',';
				})
				item.addrids = dizhi;
				delete item.isDisabled
			let {data,code} = await this.api.Postaddressupdate({
				unit:item.unit,
				realname:item.realname,
				phone:item.phone,
				addrid:item.addrids,
				is_default:item.is_default,
				address:item.address,
				address_id:item.id,
				tel:item.tel
			});
				// let {code} = await this.api.Postaddressadd(addruleForm);
				if(code==200){
					this.$message({ message: '地址修改成功', type: 'success' });
					this.Postaddressget();
					this.isDisabled=true;
				}
		}
		else
			this.$message({ message: '手机号不能为空', type: 'warning' });
	},
	async Postaddressget(){//获取地址列表
		this.loading = true;
		let {data} = await this.api.Postaddressget();
		data.data.forEach(v=>{
			v.addrid = [v.province_id,v.city_id,v.area_id];
			v.isDisabled = true;
		})
		this.siteList = data.data;
		this.loading = false;
	},
	async querySearch(queryString, cb) {//单位搜索
		let {data} = await this.api.Postuserunit({title:queryString})
        cb(data);
	},
	handleSelect(e){//添加选择单位
		this.addruleForm.unit = e.name;
	},
	closeform(done) {//关闭添加地址
		this.$refs.adddizhi.resetFields();
		if(done) done();
		this.dialogVisible = false;
	},
	adddizhi(){//添加地址
		this.$refs.adddizhi.validate(async (valid) => {
		if (!valid) return;
		this.isTosub = false;
		let dizhi = '';
		let addruleForm = this.addruleForm;
			addruleForm.addrid.forEach(v=>{
				dizhi+=v+',';
			})
			addruleForm.addrid = dizhi;
			addruleForm.is_default = addruleForm.is_default?1:0;
			let {code} = await this.api.Postaddressadd(addruleForm);
			if(code==200){
				this.$message({ message: '地址添加成功', type: 'success' });
				this.closeform('');
				this.Postaddressget();
			}
			this.isTosub = true;
        });
	},
	async Postaddresssetdefault(address_id){//设为默认地址
		this.isTosub = false;
		let {code} = await this.api.Postaddresssetdefault({address_id});
		this.Postaddressget();
		this.isTosub = true;
	},
	async Postaddressdel(address_id){//删除地址
		this.isTosub = false;
		let {data,code} = await this.api.Postaddressdel({address_id});
		if(code==200) this.$message({ showClose: true, message: '地址删除成功', type: 'success' });
		this.Postaddressget();
		this.isTosub = true;
	},
	async Postaddresstree(){//获取省市区
		let {data} = await this.api.Postaddresstree();
		this.region = this.asd(data);
	},
	asd(list){//遍历
		return list.map((v,i)=>{
			v.label = v.name;
			// delete v.name;
			v.value = v.id;
			if(v.datas){
				v.children = this.asd(v.datas);
				delete v.datas;
			}
			return v;
		})
	}
  }
};
</script>

<style lang="scss" scoped="scoped">
/deep/ .el-autocomplete,.el-cascader{
	width: 100%;
}
.laing_btn {
  width: 160px;
  height: 30px;
  line-height: 30px;
}
.site_zi {
  margin-bottom: 40px;
	&:hover .flo_right{
		display: block;
	}
  .site_title {
    font-size: 24px;
    color: #333;
    .lan {
      color: var(--themeColor);
      margin-left: 60px;
    }
  }
  .site_form {
    margin: 20px 0;
    .form_left {
      width: 100px;
      float: left;
      height: 30px;
      line-height: 30px;
      color: #333333;
    }
    .form_right {
      float: left;
	  color: #666;
	  width: 280px;
	  /deep/ .el-cascader{
		  width: 100%;
	  }
      input {
        color: #666;
        height: 30px;
        border: 1px solid #d9d9d9;
        width: 280px;
      }
      .form_select {
        width: 110px;
        margin-left: 10px;
      }
      select {
        color: #666;
        box-sizing: content-box;
        height: 34px;
        border: 1px solid #d9d9d9;
        width: 286px;
      }
    }
  }
}
</style>